import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icn-normal",
  "use": "icon-icn-normal-usage",
  "viewBox": "0 0 14 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 4\" id=\"icon-icn-normal\"><path d=\"M1.94.735a1.265 1.265 0 000 2.53H12.06a1.265 1.265 0 100-2.53H1.94z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol